module.exports = __webpack_public_path__ + "img/Group3.5a9951cf.svg";